module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "fake-header",
    staticStyle: {
      "height": "80px",
      "width": "100%",
      "background": "#218BEF"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "policy"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "policy-list"
  }, [_c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/xgzcjjd/content/post_8684827.html')
      }
    }
  }, [_c('span', [_vm._v("广东省人力资源和社会保障厅、广东省财政厅、国家税务局...")]), _vm._v(" "), _c('span', [_vm._v("2022-11-28")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/xgzcjjd/content/post_8529665.html')
      }
    }
  }, [_c('span', [_vm._v("关于征求《广州市天河区深化支持港澳青年创新创业发...")]), _vm._v(" "), _c('span', [_vm._v("2022-07-02")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/xgzcjjd/content/post_8157756.html')
      }
    }
  }, [_c('span', [_vm._v("“粤港澳大湾区”连续六年写进政府工作报告")]), _vm._v(" "), _c('span', [_vm._v("2022-03-07")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/xgzcjjd/content/post_7823030.html')
      }
    }
  }, [_c('span', [_vm._v("大湾区政策 《关于支持港澳青年在粤港澳大湾区就.. ")]), _vm._v(" "), _c('span', [_vm._v("2021-10-09")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/xgzcjjd/content/post_7802952.html')
      }
    }
  }, [_c('span', [_vm._v("一图读懂广州市粤港澳大湾区个人所得税优惠政策财政补贴申报 (境外高端人才)  ")]), _vm._v(" "), _c('span', [_vm._v("2021-09-01")])])])]), _vm._v(" "), _c('div', {
    staticClass: "question"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ques-cont"
  }, [_c('div', {
    staticClass: "cont hot"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "hot-item"
  }, [_c('div', {
    staticClass: "policy-list",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/rdjj/content/post_8824611.html')
      }
    }
  }, [_c('span', [_vm._v("稳居第一！天河针对专业法治需求推动粤港澳三地规划")]), _vm._v(" "), _c('span', [_vm._v("2023-01-12")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/rdjj/content/post_8684764.html')
      }
    }
  }, [_c('span', [_vm._v("总投资86.54亿美元!天河成港澳青年筑梦“第一扇窗”")]), _vm._v(" "), _c('span', [_vm._v("2022-11-09")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('https://mp.weixin.qq.com/s/AYNB-e-ZuOX06P_g4YzBFg')
      }
    }
  }, [_c('span', [_vm._v("T.I.T智慧园开园!打造大湾区“五乐”一体化粤港澳青年创新创业园区 ")]), _vm._v(" "), _c('span', [_vm._v("2022-06-24")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/rdjj/content/post_8529640.html')
      }
    }
  }, [_c('span', [_vm._v("最高500万元安家费，广州天河升级港澳青年双创")]), _vm._v(" "), _c('span', [_vm._v("2022-07-26")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/rdjj/content/post_8103061.html')
      }
    }
  }, [_c('span', [_vm._v("天河政务助力打造港澳青年创新创业“湾区最佳体验地...  ")]), _vm._v(" "), _c('span', [_vm._v("2022-03-01")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont hot",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "hot-item"
  }, [_c('div', {
    staticClass: "policy-list",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/rdjj/content/post_8824611.html')
      }
    }
  }, [_c('span', [_vm._v("稳居第一！天河针对专业法治需求推动粤港澳三地规划")]), _vm._v(" "), _c('span', [_vm._v("2023-01-12")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('https://mp.weixin.qq.com/s/I1bcaXYMnYC1gASqpqAIiA')
      }
    }
  }, [_c('span', [_vm._v("手把手教你!港澳青年在粤港澳大湾区就业创业政策解读来了")]), _vm._v(" "), _c('span', [_vm._v("2022-11-28")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/cjwt/content/post_8157764.html')
      }
    }
  }, [_c('span', [_vm._v("“数”说天河区港澳青年之家总部基地2021这一年 ")]), _vm._v(" "), _c('span', [_vm._v("2022-05-29")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/cjwt/content/post_7940555.html')
      }
    }
  }, [_c('span', [_vm._v("港澳台和外国的参保人如何申领广州社保卡，最新攻略.. ")]), _vm._v(" "), _c('span', [_vm._v("2021-11-30")])]), _vm._v(" "), _c('div', {
    staticClass: "policy-item",
    on: {
      "click": function($event) {
        return _vm.openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/cjwt/content/post_7403636.html')
      }
    }
  }, [_c('span', [_vm._v("湾区来内地就业的港澳居民，这个问题一定要关注！")]), _vm._v(" "), _c('span', [_vm._v("2021-06-16")])])])])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._m(6)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dawan-header"
  }, [_c('div', {
    staticClass: "content header-info"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/dawan/headtextbg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chinese-title"
  }, [_vm._v("服务简介")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("发布支持港澳青年来天河发展有关新闻、政策、办事指引，为港澳青年来天河发展提供便利服务和有力保障，支持港澳青年来穗施展才华、追梦圆梦，促进港澳青年更好融入粤港澳大湾区建设和发展。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("相关政策及解读")]), _vm._v(" "), _c('span', {
    staticClass: "more"
  }, [_vm._v("更多>>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "active"
  }, [_vm._v("热点聚焦")]), _vm._v(" "), _c('span', [_vm._v("常见问题")])]), _vm._v(" "), _c('span', {
    staticClass: "more"
  }, [_vm._v("更多>>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hot-item"
  }, [_c('div', {
    staticClass: "swiper img-swiper"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/dawan/dawan_rdzx1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-tooltip"
  }, [_vm._v("稳居第一！天河针对专业法治需求推动粤港澳三地规划")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/dawan/dawan_rdzx2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-tooltip"
  }, [_vm._v("T.I.T智慧园开园！打造大湾区“五乐”一体化粤港澳青年创新创业园区")])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination swiper-pagination3"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next-img swiper-button-next3"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev-img swiper-button-prev3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hot-item"
  }, [_c('div', {
    staticClass: "swiper img-swiper"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/dawan/dawan_cjwt1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-tooltip"
  }, [_vm._v("手把手教你！港澳青年在奥港澳大湾区就业创业政策解读来了")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/dawan/dawan_cjwt2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-tooltip"
  }, [_vm._v("手把手教你！港澳青年在奥港澳大湾区就业创业政策解读来了")])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination swiper-pagination3"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next-img swiper-button-next3"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev-img swiper-button-prev3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-one"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "tab-item-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/person.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-item-text"
  }, [_vm._v("\n            港澳居民政务服务事项\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "active-line"
  }, [_c('div', {
    staticClass: "triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item active"
  }, [_c('div', {
    staticClass: "tab-item-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/legal.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-item-text"
  }, [_vm._v("\n            港澳企业政务服务事项\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "active-line"
  }, [_c('div', {
    staticClass: "triangle"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one-cont"
  }, [_c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("港澳居民政务服务事项")]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "tab-two"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon1.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("全部")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon2.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("企业开办")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon3.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("用工招聘")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon4.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("缴费纳税")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item active"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon5.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("生产经营")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/fr-icon6.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("破产注销")])])]), _vm._v(" "), _c('div', {
    staticClass: "two-cont"
  }, [_c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("企业开办")]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("用公招聘")]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("缴费纳税")]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("办事服务")])]), _vm._v(" "), _c('div', {
    staticClass: "btngroup"
  }, [_c('div', [_c('input', {
    staticStyle: {
      "vertical-align": "-2px"
    },
    attrs: {
      "type": "checkbox",
      "name": "level"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checklabeltext",
    attrs: {
      "for": "level"
    }
  }, [_vm._v("仅显示本级")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('span', {
    staticClass: "dropdown-toggle droptext",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                                          全部部门"), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("部门")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("部门")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('span', {
    staticClass: "dropdown-toggle droptext",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                                          全部对象"), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("对象")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("对象")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('span', {
    staticClass: "dropdown-toggle droptext",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                                          全部类型"), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("类型")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("类型")])])])]), _vm._v(" "), _c('div', {
    staticClass: "search-form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "请输入您要办理的事项"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "service-table dawan-servive-table"
  }, [_c('div', {
    staticClass: "service-head"
  }, [_c('div', [_vm._v("服务事项名称")]), _vm._v(" "), _c('div', [_vm._v("解读材料")]), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('div', {
    staticClass: "service-body"
  }, [_c('div', {
    staticClass: "service-item"
  }, [_c('div', [_vm._v("涉外收养登记")]), _vm._v(" "), _c('div', [_vm._v("市民政局")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("办事指南")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("在线办理")])])]), _vm._v(" "), _c('div', {
    staticClass: "service-item"
  }, [_c('div', [_vm._v("华侨及居住在香港、澳门、台湾地区的中国公民在内地收养登记")]), _vm._v(" "), _c('div', [_vm._v("市民政局")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("办事指南")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("在线办理")])])]), _vm._v(" "), _c('div', {
    staticClass: "service-item"
  }, [_c('div', [_vm._v("撤销中国公民收养登记")]), _vm._v(" "), _c('div', [_vm._v("市民政局")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("办事指南")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("在线办理")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "previous disabled"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Previous"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('li', {
    staticClass: "next"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Next"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "page-length list-inline"
  }, [_c('li', [_c('span', [_vm._v("跳至")])]), _vm._v(" "), _c('li', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('li', [_c('span', [_vm._v("页")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("破产注销")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a39d7752"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dawan.vue
// module id = 1164
// module chunks = 0